module.exports = __webpack_public_path__ + "img/booth-graphics.9f72ede7.svg";